import {cloneDeep, get, pickBy} from 'lodash';
import {getArray, getBoolean, getObject, getString, resetObjectValues} from 'Core/helpers/data';
import {MessageContentDataObject} from "../dataObjects";
import * as viberCarouselEditorItemDataMap from 'Components/advanced/ViberCarousel/dataMap/item';

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {MessageContentDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);
	
	let bodySource;
	try { bodySource = JSON.parse(getString(result, 'bodySource')); } 
	catch (e) { bodySource = undefined; }

	result = new MessageContentDataObject(
		getString(result, 'id'),
		getString(result, 'messageType'),
		getString(result, 'subject'),
		getString(result, 'body'),
		bodySource,
		get(result, 'image', null),
		getBoolean(result, 'containsVideo'),
		getString(result, 'videoUrl'),
		getString(result, 'videoThumbnail'),
		get(result, 'link', null),
		getString(result, 'linkText'),
		(!!result?.carouselItems ?
			getArray(result, 'carouselItems').map(viberCarouselEditorItemDataMap.input) :
			null
		),
		getObject(result, 'customFields'),
		getObject(result, 'replacements'),
		getString(result, 'templateId')
	);

	return result;
}

/**
 * Get output data from input data
 * @param {MessageContentDataObject} inputData - Input data.
 * @return {Object}
 */
export const output = inputData => {
	let result = cloneDeep(inputData);
	
	let bodySource;
	try { bodySource = JSON.stringify(inputData.bodySource); } 
	catch (e) { bodySource = undefined; }

	result = {
		id: result.id,
		messageType: result.messageType,
		subject: result.subject,
		body: result.body,
		bodySource,
		image: getString(result, 'image', '', true),
		videoUrl: result.video,
		videoThumbnail: result.videoThumbnail,
		containsVideo: result.containsVideo,
		link: getString(result, 'link', '', true),
		linkText: result.linkText,
		carouselItems: (
			!!result.carouselItems ? 
				getArray(result, 'carouselItems').map(viberCarouselEditorItemDataMap.output) :
				null
		),
		// Remove undefined object keys
		customFields: pickBy(result.customFields, (v, k) => k !== 'undefined'),
		replacements: pickBy(result.replacementFields, (v, k) => k !== 'undefined'),
		templateId: result.templateId,
	};

	// Set proper empty values expected by the API
	result = resetObjectValues(result, {
		customFields: {},
	});

	return result;
}